import {
  Component,
  inject,
  input,
  OnInit
} from '@angular/core';
import {
  productCardModalTableResources,
  ProductCardModalTableResourceType
} from "../../../../../../core/models/resource/tables/product-card-resource-types";
import {TechnicalParametersService} from "../../../services/technical-parameters.service";
import {DesignBlocksService} from "../../../services/design-blocks.service";
import {MarketingBlocksService} from "../../../services/marketing-blocks.service";
import {FiltersValues} from "../../../../../../core/types/records-table.types";
import {needArticleIdForDefaultFilters, needProductIdForDefaultFilters} from "../../../configs/pc-tables-config";
import {ProductCardData} from "../../../types/product-card-data.types";
import {defaultProductCardData} from "../../../configs/default-product-card-data";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {
  RecordsTableContainerComponent
} from "../../../../../../core/components/records-table-container/records-table-container.component";
import {LoaderComponent} from "../../../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-pc-tables',
  standalone: true,
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    RecordsTableContainerComponent,
    LoaderComponent
  ],
  templateUrl: './pc-tables.component.html',
  styleUrl: './pc-tables.component.scss'
})
export class PcTablesComponent implements OnInit {
  productCardId = input.required<number>();
  productCardData  = input<ProductCardData>(defaultProductCardData);
  isVisibleDesc = input<boolean>(true);

  private technicalParametersService: TechnicalParametersService = inject(TechnicalParametersService);
  private designBlocksService: DesignBlocksService = inject(DesignBlocksService);
  private marketingBlocksService: MarketingBlocksService = inject(MarketingBlocksService);

  public readonly productCardModalTableResourcesKeys = Object.keys(productCardModalTableResources) as Array<ProductCardModalTableResourceType>;
  public readonly productCardModalTableResources = productCardModalTableResources;
  public filtersValuesMap: Record<string, FiltersValues> = {};
  public isInitialized = false;

  public async ngOnInit(): Promise<void> {
    if (this.productCardId()) {
      this.setFiltersValuesMap();
      await this.initialComponent()
        .finally(() => this.isInitialized = true);
    }
  }

  private setFiltersValuesMap(): void {
    this.filtersValuesMap = this.productCardModalTableResourcesKeys.reduce((acc, key) => {
      acc[key] = {
        productCardId: this.productCardId(),
        ...(needProductIdForDefaultFilters.includes(key) && { productId: this.productCardData().productId }),
        ...(needArticleIdForDefaultFilters.includes(key) && { article: this.productCardData().attachedArticles }),
      };

      return acc;
    }, {} as Record<string, FiltersValues>);
  }

  private async initialComponent(): Promise<void> {
    await Promise.any([
      this.technicalParametersService.syncPassportArticles(this.productCardId()),
      this.designBlocksService.initializeDesignBlocks(this.productCardId()),
      this.marketingBlocksService.initializeMarketingBlocks(this.productCardId())
    ]);
  }
}
